import { render, staticRenderFns } from "./4mList.vue?vue&type=template&id=afe3f6f0"
import script from "./4mList.vue?vue&type=script&lang=js"
export * from "./4mList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afe3f6f0')) {
      api.createRecord('afe3f6f0', component.options)
    } else {
      api.reload('afe3f6f0', component.options)
    }
    module.hot.accept("./4mList.vue?vue&type=template&id=afe3f6f0", function () {
      api.rerender('afe3f6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mList.vue"
export default component.exports